import React from "react";
import { IoIosLink } from "react-icons/io";
import styles from "./style.module.scss";
import { data } from "./data";
import { Link } from "react-router-dom";
import { GrView } from "react-icons/gr";
import ScrollAnimation from "react-animate-on-scroll";

const PortfolioPage = () => {
  return (
    <div className={styles.PortfolioPage}>
      <div className={styles.top_header}>
        <div className={styles.headerBTN}>
          <IoIosLink /> <span>Portfolio</span>
        </div>
        <p>Take a look at my past experience</p>
      </div>
      <div className={styles.cards}>
        {data.map((el, index) =>
          index === 0 ? (
            <div className={styles.card} key={el.id}>
              <div className={styles.card} key={el.id}>
                <div className={styles.image}>
                  <img src={el.image} alt={el.title} />
                </div>
                <div className={styles.card_footer}>
                  <div className={styles.card_footer_left}>
                    <img src="/assets/images/dot-exp.svg" alt="icon" />{" "}
                    <span>
                      {el.id}- {el.title}
                    </span>
                  </div>
                  <div className={styles.card_footer_right}>
                    <Link to={el.link} target="_blank">
                      View On Browser <GrView />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <ScrollAnimation
              animateIn="fadeIn"
              animateOnce={true}
              className={styles.card}
              key={el.id}
            >
              <div className={styles.card} key={el.id}>
                <div className={styles.image}>
                  <img src={el.image} alt={el.title} />
                </div>
                <div className={styles.card_footer}>
                  <div className={styles.card_footer_left}>
                    <img src="/assets/images/dot-exp.svg" alt="icon" />{" "}
                    <span>
                      {el.id}- {el.title}
                    </span>
                  </div>
                  <div className={styles.card_footer_right}>
                    <Link to={el.link} target="_blank">
                      View On Browser <GrView />
                    </Link>
                  </div>
                </div>
              </div>
            </ScrollAnimation>
          )
        )}
      </div>
    </div>
  );
};

export default PortfolioPage;
